import React from "react";
import { firestore } from "../../config/firebase";
import { Button, Input, message } from "antd";
import { useAuthContext } from "../../contexts/AuthContext"
import { collection, doc, getDocs, query, setDoc, where } from "firebase/firestore";
import { useEffect, useState } from "react";
// const initialState = {  }
export default function Quiz() {
  const { user, isAuth } = useAuthContext()
  const [state, setState] = useState([]);
  const [answers, setAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [quizes, setQuizes] = useState([])
  const [questions, setQuestions] = useState([])
  const [isQuiz, setIsQuiz] = useState(true)
  const handleChange = (e) => {
    const { name, value } = e.target;
    const index = state.findIndex((item) => item.name === name);

    if (index !== -1) {
      setState((prevState) => [
        ...prevState.slice(0, index),
        { name, value },
        ...prevState.slice(index + 1),
      ]);
    } else {
      setState((prevState) => [...prevState, { name, value }]);
    }
  };

  const getQuizData = async () => {
    try {
      const q = query(collection(firestore, 'quizes'), where('status', '==', 'active'));
      const querySnapshot = await getDocs(q);
      const array = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        array.push(data);
      });
      setQuizes(array)
    } catch (error) {
      console.error(error)
    }
  }
  const getQuestionData = async () => {
    if (isAuth) {
      try {
        const q = query(collection(firestore, 'questions'), where('status', '==', 'active'));
        const querySnapshot = await getDocs(q);
        const array = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          array.push(data);
        });
        setQuestions(array)
      } catch (error) {
        console.error(error)
      }
    }
  }
  const tryAgain = () => {
    setShowResults(false)
    setAnswers({})
  }
  useEffect(() => {
    getQuestionData()
    getQuizData()
  }, [])

  const handleOptionChange = (questionIndex, selectedOption) => {
    setAnswers({ ...answers, [questionIndex]: selectedOption });
  };

  const calculateScore = () => {
    let score = 0;
    quizes.forEach((question, index) => {
      if (answers[index] === question.correctAnswer) {
        score++;
      }
    });
    return score;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowResults(true);
    let quizAttemptedId = Math.random().toString(36).slice(2)
    if (isAuth) {
      let quizRecord = {
        totalQuestions: quizes.length,
        correctQuestions: calculateScore(),
        attemptedBy: user.fullName,
        attemptedUserId: user.uid,
        phoneNumber: user.phoneNumber,
        quizAttemptedId: quizAttemptedId,
        attemptedTime: new Date().toLocaleString(),
        status: "active"
      }
      await setDoc(doc(firestore, "quizRecord", quizAttemptedId), quizRecord);
      message.success("Your Quiz Submitted  successfully")
    }
    let questionAttemptedId = Math.random().toString(36).slice(2)
    if (isAuth) {
      let questionRecord = {
        answers: state,
        totalQuestions: questions.length,
        attemptedBy: user.fullName,
        attemptedUserId: user.uid,
        phoneNumber: user.phoneNumber,
        questionAttemptedId: questionAttemptedId,
        attemptedTime: new Date().toLocaleString(),
        status: "active"
      }
      await setDoc(doc(firestore, "questionsResult", questionAttemptedId), questionRecord);
      message.success("Your Question Submitted  successfully")
    }
  };

  return (
    
    <div className="mt-24  text-[#fffa8a] px-4 md:px-10 ">
      {isAuth &&
        <div className="flex justify-content-center  mt-5">
          <Button className='px-10  mx-auto text-center rounded-2xl hover:rounded-lg ' onClick={() => setIsQuiz(!isQuiz)} style={{ background: "transparent", border: " 1px solid #fffa8a", color: "#fffa8a" }} >
            {isQuiz ? "Questions" : "Quiz"}</Button></div>

      }
      {isQuiz ? <>  <h1 className="font-bold text-[48px] text-center underline">Quiz Questions</h1>
        <form onSubmit={handleSubmit} className="ps-10">
          {!showResults && quizes.map((question, index) => (
            <div key={index}  >
              <div className="pt-4 pb-2" >
                <h2 className="text-xl font-bold inline">Question {index + 1}:</h2>
                <p className="text-xl italic inline ps-1">{question.question}</p>
              </div>

              {
                question.options.map((option, optionIndex) => (
                  <div key={optionIndex} className="py-1">
                    <label>
                      <input
                        type="radio"
                        name={`question_${index}`}
                        value={option}
                        checked={answers[index] === option}
                        onChange={() => handleOptionChange(index, option)}
                      />
                      {option}
                    </label>
                  </div>
                ))
              }
            </div>
          ))
          }
        </form >
      </> :
        <>
          <h1 className="font-bold text-[48px] text-center underline"> Questions Answers</h1>
          <form onSubmit={handleSubmit} className="ps-10">
            {!showResults && questions.map((question, index) => (
              <div key={index}  >
                <div className="pt-4 pb-2" >
                  <h2 className="text-xl font-bold inline">Question {index + 1}:</h2>
                  <p className="text-xl italic inline ps-1">{question.question}</p>
                  <Input.TextArea placeholder='Input your description' className="bg-transparent border-[#fffa8a] text-[#fffa8a]" name={`${question.question}`} onChange={handleChange} />

                </div>
              </div>
            ))
            }
          </form >
        </>}
      {!showResults && (<div className="flex justify-content-center md:block mt-4">
        <Button className='px-10  mx-auto text-center rounded-2xl hover:rounded-lg ' onClick={handleSubmit} htmlType="submit" style={{ background: "transparent", border: " 1px solid #fffa8a", color: "#fffa8a" }} >
          Submit</Button></div>)}
      {showResults && (
        <div>
          <h2 className="text-3xl underline italic mt-6 text-center">Results</h2>
          <p className="text-xl mt-6 text-center">Your score is: <span className="text-2xl font-bold">{calculateScore()}</span> out of {quizes.length}</p>
          <div className="flex justify-content-center  mt-5">
            <Button className='px-10  mx-auto text-center rounded-2xl hover:rounded-lg ' onClick={tryAgain} style={{ background: "transparent", border: " 1px solid #fffa8a", color: "#fffa8a" }} >
              Try Again</Button></div>
        </div>
      )}
    </div >
  );
}
